<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-12-09 16:21:07
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-20 16:28:20
-->
<template>
	<el-dialog title="公开推荐商品给达人" width="40%" :visible.sync="dialogPublicVisible">
		<template slot="title">
			<p>
				<span>公开推荐商品给达人</span>
				<span class="fz-14 yx-color-text-regular ml-6">{{ '(共' + total + '个商品)' }}</span>
			</p>
		</template>
		<div class="tips">
			<p>
				<i class="el-icon-info yx-color-primary"></i>
				公开分享的商品被查看后，请及时将查看人“添加为联系人”，未添加为联系人的查看人不能通过小程序选品！可在“
				<span class="yx-color-primary" @click="skipFun">推广记录-商品查看记录</span>”中查看并添加为联系人
			</p>
		</div>
		<div class="flex mt-30 flex-align-center flex-just-center">
			<div class="share-img mr-20">
				<img :src="wxImgUrl" alt="" />
			</div>
			<div>
				<p class="font-bold fz-14 mb-10">分享微信小程序卡片</p>
				<p class="mb-10 yx-color-text-primary">1、微信扫描下方二维码</p>
				<p class="mb-10 yx-color-text-primary">2、点击页面右下角的‘立即分享’按钮</p>
				<p class="yx-color-text-primary">3、选择微信达人招商分享到会话</p>
			</div>
		</div>
		<p class="fz-12 yx-color-text-regular mt-10">注意：同团队成员打开小程序或扫描二维码可以协助您进行推品，但没有“加入选品表”的操作</p>
		<div slot="footer">
			<el-button @click="goBack">上一步</el-button>
			<el-button type="primary" @click="confirm">完 成</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			dialogPublicVisible: false,
			total: 0,
			wxImgUrl: '',
		};
	},
	methods: {
		initPublic(total, wxImgUrl) {
			this.wxImgUrl = wxImgUrl;
			this.dialogPublicVisible = true;
			this.total = total;
		},
		skipFun() {
			let handLink = this.$router.resolve({
				path: '/shopManage/extenTecord/list',
			});
			window.open(handLink.href, '_blank');
		},
		goBack() {
			this.dialogPublicVisible = false;
			this.$emit('goBack');
		},
		confirm() {
			this.dialogPublicVisible = false;
		},
	},
};
</script>
<style lang="less" scoped>
.tips {
	padding: 10px 20px;
	background-color: #e9f1ff;
	border: 1px solid #bdd5ff;

	span {
		cursor: pointer;
	}
}

.share-img {
	width: 200px;
	height: 200px;
}

.public,
.appoint {
	padding: 24px 20px;
	border: 1px solid #eeeeee;
}
</style>
